import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import moment from 'moment'
import React, { Component } from 'react'
import { i18n } from '../../domain/index'
import { TotalSalesNote } from '../../domain/reporting/totalSales/types'
import css from './modal.css'

type Props = {
  spotlight?: TotalSalesNote
  clearSpotlight: () => void
}

class Modal extends Component<Props> {
  render() {
    const { spotlight, clearSpotlight } = this.props
    return (
      <Dialog
        open={!!spotlight}
        keepMounted
        onClose={() => clearSpotlight()}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle id='alert-dialog-slide-title'>
          {i18n.t('reporting.notesFromDay')} {spotlight && moment(spotlight.date).format('DD.MM.YYYY')}
        </DialogTitle>
        {spotlight && (
          <DialogContent>
            <DialogContentText
              style={{
                whiteSpace: 'pre-wrap',
              }}
              id='alert-dialog-slide-description'
            >
              {spotlight.notes}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions className={css.alertDialogSlideActions}>
          <Button onClick={() => clearSpotlight()} color='primary' variant='contained'>
            {i18n.t('buttons.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default Modal
